import React from 'react';
import { GamePage } from '../../components/gamePage';
import { theWotLeWot } from '../../games/Games';

const TheWotlewot = () => <GamePage gameDetails={theWotLeWot} />;

export default TheWotlewot;
